import { render, staticRenderFns } from "./orderRefund.vue?vue&type=template&id=3c81edfc&scoped=true"
import script from "./orderRefund.vue?vue&type=script&lang=js"
export * from "./orderRefund.vue?vue&type=script&lang=js"
import style0 from "./orderRefund.vue?vue&type=style&index=0&id=3c81edfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c81edfc",
  null
  
)

export default component.exports